import styled from '@emotion/styled'
import { ITheme } from 'utils/type'

interface IStyledProps {
  theme: ITheme
}

export const ReleaseBannerIconPairDiv = styled.div`
  label: ReleaseBannerIconPairDiv;
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 18px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const ReleaseBannerIconPairText = styled.div`
  label: ReleaseBannerIconPairText;
  font-size: 16px;
  line-height: 22px;
`

export const ReleaseBannerContainerDiv = styled.div<IStyledProps>`
  label: ReleaseBannerContainerDiv;
  background-color: ${(props) => props.theme.backgrounds.backGround3};
  width: 100%;
  padding-top: 18px;
`

export const ReleaseBannerTitleP = styled.p<IStyledProps>`
  label: ReleaseBannerTitleP;
  line-height: 40px;
  font-size: 26px;
  color: ${(props) => props.theme.colors.primary};
  text-align: center;
  padding: 0px 18px;
`

export const ReleaseBannerIconTextContainerDiv = styled.div`
  label: ReleaseBannerIconTextContainerDiv;
  display: flex;
`

export const ReleaseBannerButtonDiv = styled.div`
  label: ReleaseBannerButtonDiv;
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
`
